import request from '@utils/request'

export const state = {
  cachedMembers: [],
}

export const getters = {}

export const mutations = {
  CACHE_MEMBERS(state, currentMembers) {
    state.cachedMembers = currentMembers
  },
}

export const actions = {
  findByPhone({ commit }, phoneData) {
    return request
      .post('/admin/merchant/member/searchByPhone', phoneData, {
        errorHandle: false,
      })
      .then((response) => response.items)
  },
  fetchSingle({ commit }, memberId) {
    return request
      .get(`/admin/merchant/member/${memberId}`)
      .then((response) => response.items)
  },
  store({ commit }, storeData) {
    return request.post('/admin/merchant/member/store', storeData)
  },
  fetchList({ commit }, query) {
    return request
      .all([
        request.post('/admin/merchant/member/search', query),
        request.post('/admin/merchant/member/search', {
          ...query,
          page: 0,
          limit: 0,
        }),
      ])
      .then(
        request.spread((per, all) => {
          commit('CACHE_MEMBERS', all.items)
          return {
            items: per.items,
            total: per.pagination.total,
          }
        })
      )
  },
  fetchTags({ commit }, search) {
    return request
      .post('/admin/merchant/member/tag/search', search)
      .then((response) => response)
  },
  storeTag({ commit }, storeData) {
    return request.post('/admin/merchant/member/tag/store', storeData)
  },
  removeTags({ commit }, removeData) {
    return request.post('/admin/merchant/member/tag/remove', removeData)
  },
  applyTags({ commit }, applyData) {
    return request.post('/admin/merchant/member/tag/apply', applyData)
  },
}
